<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-row class="pt-3">
        <v-col cols="12" class="justify-center d-flex">
          <span v-on="on" v-bind="attrs">Não estou conseguindo acessar</span>
        </v-col>
      </v-row>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Problemas no acesso?</v-card-title>
      <v-card-text class="subtitle-1">
        Entre em contato com o Dpto. de Recursos Humanos pelo fone (46)
        3533-8125 para recuperar seu acesso.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>